import CookieUtils from "../../../helpers/cookie-utils";

export default () => {
  const emailCookieValue = CookieUtils.get('BISNEmailAddress');
  let userEmail = '';
  if (emailCookieValue) {
    userEmail = window.atob(emailCookieValue);
  }

  return userEmail;
}
